/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { usuarioCarpetaPersonalIdUserPatch } from '../fn/user/usuario-carpeta-personal-id-user-patch';
import { UsuarioCarpetaPersonalIdUserPatch$Params } from '../fn/user/usuario-carpeta-personal-id-user-patch';
import { usuarioContraseniaIdUserPatch } from '../fn/user/usuario-contrasenia-id-user-patch';
import { UsuarioContraseniaIdUserPatch$Params } from '../fn/user/usuario-contrasenia-id-user-patch';
import { usuarioContraseniaPorCodigoRecuperacionPatch } from '../fn/user/usuario-contrasenia-por-codigo-recuperacion-patch';
import { UsuarioContraseniaPorCodigoRecuperacionPatch$Params } from '../fn/user/usuario-contrasenia-por-codigo-recuperacion-patch';
import { usuarioCorreoIdUserPatch } from '../fn/user/usuario-correo-id-user-patch';
import { UsuarioCorreoIdUserPatch$Params } from '../fn/user/usuario-correo-id-user-patch';
import { usuarioEliminarCuenta1234Patch } from '../fn/user/usuario-eliminar-cuenta-1234-patch';
import { UsuarioEliminarCuenta1234Patch$Params } from '../fn/user/usuario-eliminar-cuenta-1234-patch';
import { usuarioEnviarCvCorreoGet } from '../fn/user/usuario-enviar-cv-correo-get';
import { UsuarioEnviarCvCorreoGet$Params } from '../fn/user/usuario-enviar-cv-correo-get';
import { usuarioEnviarMultiplesCorreosGet } from '../fn/user/usuario-enviar-multiples-correos-get';
import { UsuarioEnviarMultiplesCorreosGet$Params } from '../fn/user/usuario-enviar-multiples-correos-get';
import { usuarioFiltrarPorCandidatoGet } from '../fn/user/usuario-filtrar-por-candidato-get';
import { UsuarioFiltrarPorCandidatoGet$Params } from '../fn/user/usuario-filtrar-por-candidato-get';
import { usuarioIdUserGet } from '../fn/user/usuario-id-user-get';
import { UsuarioIdUserGet$Params } from '../fn/user/usuario-id-user-get';
import { usuarioIdUserPatch } from '../fn/user/usuario-id-user-patch';
import { UsuarioIdUserPatch$Params } from '../fn/user/usuario-id-user-patch';
import { usuarioNumeroPorCandidatoGet } from '../fn/user/usuario-numero-por-candidato-get';
import { UsuarioNumeroPorCandidatoGet$Params } from '../fn/user/usuario-numero-por-candidato-get';
import { usuarioNumeroPostulantesActivosGet } from '../fn/user/usuario-numero-postulantes-activos-get';
import { UsuarioNumeroPostulantesActivosGet$Params } from '../fn/user/usuario-numero-postulantes-activos-get';
import { usuarioObtenerActualizarPerfilIdUserGet } from '../fn/user/usuario-obtener-actualizar-perfil-id-user-get';
import { UsuarioObtenerActualizarPerfilIdUserGet$Params } from '../fn/user/usuario-obtener-actualizar-perfil-id-user-get';
import { usuarioObtenerCodigoRecuperacionGet } from '../fn/user/usuario-obtener-codigo-recuperacion-get';
import { UsuarioObtenerCodigoRecuperacionGet$Params } from '../fn/user/usuario-obtener-codigo-recuperacion-get';
import { usuarioObtenerExportarPorIdsGet } from '../fn/user/usuario-obtener-exportar-por-ids-get';
import { UsuarioObtenerExportarPorIdsGet$Params } from '../fn/user/usuario-obtener-exportar-por-ids-get';
import { usuarioObtenerPorCredencialesAdministradorGet } from '../fn/user/usuario-obtener-por-credenciales-administrador-get';
import { UsuarioObtenerPorCredencialesAdministradorGet$Params } from '../fn/user/usuario-obtener-por-credenciales-administrador-get';
import { usuarioObtenerPorCredencialesGet } from '../fn/user/usuario-obtener-por-credenciales-get';
import { UsuarioObtenerPorCredencialesGet$Params } from '../fn/user/usuario-obtener-por-credenciales-get';
import { usuarioObtenerPorEmailGet } from '../fn/user/usuario-obtener-por-email-get';
import { UsuarioObtenerPorEmailGet$Params } from '../fn/user/usuario-obtener-por-email-get';
import { usuarioObtenerPorFolderIdCompanyUserFolderGet } from '../fn/user/usuario-obtener-por-folder-id-company-user-folder-get';
import { UsuarioObtenerPorFolderIdCompanyUserFolderGet$Params } from '../fn/user/usuario-obtener-por-folder-id-company-user-folder-get';
import { usuarioObtenerPorNombreCompletoGet } from '../fn/user/usuario-obtener-por-nombre-completo-get';
import { UsuarioObtenerPorNombreCompletoGet$Params } from '../fn/user/usuario-obtener-por-nombre-completo-get';
import { usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet } from '../fn/user/usuario-obtener-por-usuario-filtro-candidato-id-user-get';
import { UsuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Params } from '../fn/user/usuario-obtener-por-usuario-filtro-candidato-id-user-get';
import { usuarioOfimaticaIdUserPatch } from '../fn/user/usuario-ofimatica-id-user-patch';
import { UsuarioOfimaticaIdUserPatch$Params } from '../fn/user/usuario-ofimatica-id-user-patch';
import { usuarioPeticionActualizacionCorreoIdUserPatch } from '../fn/user/usuario-peticion-actualizacion-correo-id-user-patch';
import { UsuarioPeticionActualizacionCorreoIdUserPatch$Params } from '../fn/user/usuario-peticion-actualizacion-correo-id-user-patch';
import { usuarioPost } from '../fn/user/usuario-post';
import { UsuarioPost$Params } from '../fn/user/usuario-post';
import { usuarioPretencionSalarialIdUserPatch } from '../fn/user/usuario-pretencion-salarial-id-user-patch';
import { UsuarioPretencionSalarialIdUserPatch$Params } from '../fn/user/usuario-pretencion-salarial-id-user-patch';
import { usuarioPrivacidadPerfilIdUserPatch } from '../fn/user/usuario-privacidad-perfil-id-user-patch';
import { UsuarioPrivacidadPerfilIdUserPatch$Params } from '../fn/user/usuario-privacidad-perfil-id-user-patch';
import { usuarioRegistrarConRedesSocialesPost } from '../fn/user/usuario-registrar-con-redes-sociales-post';
import { UsuarioRegistrarConRedesSocialesPost$Params } from '../fn/user/usuario-registrar-con-redes-sociales-post';
import { ApiResponse } from '../api-response.model';
import { Profile } from 'src/app/shared/model/user';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `usuarioPost()` */
  static readonly UsuarioPostPath = '/usuario';

  /**
   * insert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPost$Response(
    params?: UsuarioPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioPost(this.http, this.rootUrl, params, context);
  }

  /**
   * insert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPost(
    params?: UsuarioPost$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioRegistrarConRedesSocialesPost()` */
  static readonly UsuarioRegistrarConRedesSocialesPostPath =
    '/usuario/registrar-con-redes-sociales';

  /**
   * insertWithSocialNetwork.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioRegistrarConRedesSocialesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioRegistrarConRedesSocialesPost$Response(
    params?: UsuarioRegistrarConRedesSocialesPost$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioRegistrarConRedesSocialesPost(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * insertWithSocialNetwork.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioRegistrarConRedesSocialesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioRegistrarConRedesSocialesPost(
    params?: UsuarioRegistrarConRedesSocialesPost$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioRegistrarConRedesSocialesPost$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioIdUserGet()` */
  static readonly UsuarioIdUserGetPath = '/usuario/{idUser}';

  /**
   * getById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioIdUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioIdUserGet$Response(
    params: UsuarioIdUserGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioIdUserGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioIdUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioIdUserGet(
    params: UsuarioIdUserGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioIdUserGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioIdUserPatch()` */
  static readonly UsuarioIdUserPatchPath = '/usuario/{idUser}';

  /**
   * updatePersonalInformation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioIdUserPatch$Response(
    params: UsuarioIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioIdUserPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * updatePersonalInformation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioIdUserPatch(
    params: UsuarioIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioIdUserPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioContraseniaPorCodigoRecuperacionPatch()` */
  static readonly UsuarioContraseniaPorCodigoRecuperacionPatchPath =
    '/usuario/contrasenia-por-codigo-recuperacion';

  /**
   * updatePasswordByRecoveryCode.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioContraseniaPorCodigoRecuperacionPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioContraseniaPorCodigoRecuperacionPatch$Response(
    params?: UsuarioContraseniaPorCodigoRecuperacionPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioContraseniaPorCodigoRecuperacionPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updatePasswordByRecoveryCode.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioContraseniaPorCodigoRecuperacionPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioContraseniaPorCodigoRecuperacionPatch(
    params?: UsuarioContraseniaPorCodigoRecuperacionPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioContraseniaPorCodigoRecuperacionPatch$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioOfimaticaIdUserPatch()` */
  static readonly UsuarioOfimaticaIdUserPatchPath =
    '/usuario/ofimatica/{idUser}';

  /**
   * updateKnowledge.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioOfimaticaIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioOfimaticaIdUserPatch$Response(
    params: UsuarioOfimaticaIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioOfimaticaIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updateKnowledge.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioOfimaticaIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioOfimaticaIdUserPatch(
    params: UsuarioOfimaticaIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioOfimaticaIdUserPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioPretencionSalarialIdUserPatch()` */
  static readonly UsuarioPretencionSalarialIdUserPatchPath =
    '/usuario/pretencion-salarial/{idUser}';

  /**
   * updateWagePretention.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioPretencionSalarialIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPretencionSalarialIdUserPatch$Response(
    params: UsuarioPretencionSalarialIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioPretencionSalarialIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updateWagePretention.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioPretencionSalarialIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPretencionSalarialIdUserPatch(
    params: UsuarioPretencionSalarialIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioPretencionSalarialIdUserPatch$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioCarpetaPersonalIdUserPatch()` */
  static readonly UsuarioCarpetaPersonalIdUserPatchPath =
    '/usuario/carpeta-personal/{idUser}';

  /**
   * updateUrlPersonalFile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioCarpetaPersonalIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioCarpetaPersonalIdUserPatch$Response(
    params: UsuarioCarpetaPersonalIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioCarpetaPersonalIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updateUrlPersonalFile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioCarpetaPersonalIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioCarpetaPersonalIdUserPatch(
    params: UsuarioCarpetaPersonalIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioCarpetaPersonalIdUserPatch$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioCorreoIdUserPatch()` */
  static readonly UsuarioCorreoIdUserPatchPath = '/usuario/correo/{idUser}';

  /**
   * updateEmail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioCorreoIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioCorreoIdUserPatch$Response(
    params: UsuarioCorreoIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioCorreoIdUserPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * updateEmail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioCorreoIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioCorreoIdUserPatch(
    params: UsuarioCorreoIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioCorreoIdUserPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioPrivacidadPerfilIdUserPatch()` */
  static readonly UsuarioPrivacidadPerfilIdUserPatchPath =
    '/usuario/privacidad-perfil/{idUser}';

  /**
   * updatePublicProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioPrivacidadPerfilIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPrivacidadPerfilIdUserPatch$Response(
    params: UsuarioPrivacidadPerfilIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioPrivacidadPerfilIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updatePublicProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioPrivacidadPerfilIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPrivacidadPerfilIdUserPatch(
    params: UsuarioPrivacidadPerfilIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioPrivacidadPerfilIdUserPatch$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioContraseniaIdUserPatch()` */
  static readonly UsuarioContraseniaIdUserPatchPath =
    '/usuario/contrasenia/{idUser}';

  /**
   * updatePassword.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioContraseniaIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioContraseniaIdUserPatch$Response(
    params: UsuarioContraseniaIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioContraseniaIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * updatePassword.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioContraseniaIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioContraseniaIdUserPatch(
    params: UsuarioContraseniaIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioContraseniaIdUserPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioEliminarCuenta1234Patch()` */
  static readonly UsuarioEliminarCuenta1234PatchPath =
    '/usuario/eliminar-cuenta/1234';

  /**
   * deleteAccount.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioEliminarCuenta1234Patch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioEliminarCuenta1234Patch$Response(
    params?: UsuarioEliminarCuenta1234Patch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioEliminarCuenta1234Patch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * deleteAccount.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioEliminarCuenta1234Patch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioEliminarCuenta1234Patch(
    params?: UsuarioEliminarCuenta1234Patch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioEliminarCuenta1234Patch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioPeticionActualizacionCorreoIdUserPatch()` */
  static readonly UsuarioPeticionActualizacionCorreoIdUserPatchPath =
    '/usuario/peticion-actualizacion-correo/{idUser}';

  /**
   * requestUpdateEmail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioPeticionActualizacionCorreoIdUserPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPeticionActualizacionCorreoIdUserPatch$Response(
    params: UsuarioPeticionActualizacionCorreoIdUserPatch$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioPeticionActualizacionCorreoIdUserPatch(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * requestUpdateEmail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioPeticionActualizacionCorreoIdUserPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  usuarioPeticionActualizacionCorreoIdUserPatch(
    params: UsuarioPeticionActualizacionCorreoIdUserPatch$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioPeticionActualizacionCorreoIdUserPatch$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioNumeroPostulantesActivosGet()` */
  static readonly UsuarioNumeroPostulantesActivosGetPath =
    '/usuario/numero-postulantes-activos';

  /**
   * countAllPostulantActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioNumeroPostulantesActivosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioNumeroPostulantesActivosGet$Response(
    params?: UsuarioNumeroPostulantesActivosGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioNumeroPostulantesActivosGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * countAllPostulantActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioNumeroPostulantesActivosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioNumeroPostulantesActivosGet(
    params?: UsuarioNumeroPostulantesActivosGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioNumeroPostulantesActivosGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioObtenerPorEmailGet()` */
  static readonly UsuarioObtenerPorEmailGetPath = '/usuario/obtener-por-email';

  /**
   * getByEmail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorEmailGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorEmailGet$Response(
    params?: UsuarioObtenerPorEmailGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorEmailGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByEmail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorEmailGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorEmailGet(
    params?: UsuarioObtenerPorEmailGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorEmailGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioObtenerPorCredencialesGet()` */
  static readonly UsuarioObtenerPorCredencialesGetPath =
    '/usuario/obtener-por-credenciales';

  /**
   * getByCredentials.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorCredencialesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorCredencialesGet$Response(
    params?: UsuarioObtenerPorCredencialesGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorCredencialesGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getByCredentials.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorCredencialesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorCredencialesGet(
    params?: UsuarioObtenerPorCredencialesGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorCredencialesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioObtenerPorCredencialesAdministradorGet()` */
  static readonly UsuarioObtenerPorCredencialesAdministradorGetPath =
    '/usuario/obtener-por-credenciales-administrador';

  /**
   * getByCredentialsAdmin.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorCredencialesAdministradorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorCredencialesAdministradorGet$Response(
    params?: UsuarioObtenerPorCredencialesAdministradorGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorCredencialesAdministradorGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getByCredentialsAdmin.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorCredencialesAdministradorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorCredencialesAdministradorGet(
    params?: UsuarioObtenerPorCredencialesAdministradorGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorCredencialesAdministradorGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioObtenerPorNombreCompletoGet()` */
  static readonly UsuarioObtenerPorNombreCompletoGetPath =
    '/usuario/obtener-por-nombre-completo';

  /**
   * getContainsFullName.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorNombreCompletoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorNombreCompletoGet$Response(
    params?: UsuarioObtenerPorNombreCompletoGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorNombreCompletoGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getContainsFullName.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorNombreCompletoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorNombreCompletoGet(
    params?: UsuarioObtenerPorNombreCompletoGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorNombreCompletoGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioObtenerCodigoRecuperacionGet()` */
  static readonly UsuarioObtenerCodigoRecuperacionGetPath =
    '/usuario/obtener-codigo-recuperacion';

  /**
   * getRecoveryCode.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerCodigoRecuperacionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerCodigoRecuperacionGet$Response(
    params?: UsuarioObtenerCodigoRecuperacionGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerCodigoRecuperacionGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getRecoveryCode.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerCodigoRecuperacionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerCodigoRecuperacionGet(
    params?: UsuarioObtenerCodigoRecuperacionGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerCodigoRecuperacionGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioObtenerActualizarPerfilIdUserGet()` */
  static readonly UsuarioObtenerActualizarPerfilIdUserGetPath =
    '/usuario/obtener-actualizar-perfil/{idUser}';

  /**
   * getForUpdateProfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerActualizarPerfilIdUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerActualizarPerfilIdUserGet$Response(
    params: UsuarioObtenerActualizarPerfilIdUserGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerActualizarPerfilIdUserGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getForUpdateProfile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerActualizarPerfilIdUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerActualizarPerfilIdUserGet(
    params: UsuarioObtenerActualizarPerfilIdUserGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerActualizarPerfilIdUserGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioFiltrarPorCandidatoGet()` */
  static readonly UsuarioFiltrarPorCandidatoGetPath =
    '/usuario/filtrar-por-candidato';

  /**
   * filterForCandidate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioFiltrarPorCandidatoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioFiltrarPorCandidatoGet$Response(
    params?: UsuarioFiltrarPorCandidatoGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioFiltrarPorCandidatoGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * filterForCandidate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioFiltrarPorCandidatoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioFiltrarPorCandidatoGet(
    params?: UsuarioFiltrarPorCandidatoGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioFiltrarPorCandidatoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioNumeroPorCandidatoGet()` */
  static readonly UsuarioNumeroPorCandidatoGetPath =
    '/usuario/numero-por-candidato';

  /**
   * countFilterForCandidate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioNumeroPorCandidatoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioNumeroPorCandidatoGet$Response(
    params?: UsuarioNumeroPorCandidatoGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioNumeroPorCandidatoGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * countFilterForCandidate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioNumeroPorCandidatoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioNumeroPorCandidatoGet(
    params?: UsuarioNumeroPorCandidatoGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioNumeroPorCandidatoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioObtenerExportarPorIdsGet()` */
  static readonly UsuarioObtenerExportarPorIdsGetPath =
    '/usuario/obtener-exportar-por-ids';

  /**
   * getForExportByIdUsers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerExportarPorIdsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerExportarPorIdsGet$Response(
    params?: UsuarioObtenerExportarPorIdsGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerExportarPorIdsGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getForExportByIdUsers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerExportarPorIdsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerExportarPorIdsGet(
    params?: UsuarioObtenerExportarPorIdsGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerExportarPorIdsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet()` */
  static readonly UsuarioObtenerPorUsuarioFiltroCandidatoIdUserGetPath =
    '/usuario/obtener-por-usuario-filtro-candidato/{idUser}';

  /**
   * getByIdUserForFilterForCandidate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Response(
    params: UsuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getByIdUserForFilterForCandidate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet(
    params: UsuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorUsuarioFiltroCandidatoIdUserGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioObtenerPorFolderIdCompanyUserFolderGet()` */
  static readonly UsuarioObtenerPorFolderIdCompanyUserFolderGetPath =
    '/usuario/obtener-por-folder/idCompanyUserFolder';

  /**
   * getForFolder.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioObtenerPorFolderIdCompanyUserFolderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorFolderIdCompanyUserFolderGet$Response(
    params?: UsuarioObtenerPorFolderIdCompanyUserFolderGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioObtenerPorFolderIdCompanyUserFolderGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * getForFolder.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioObtenerPorFolderIdCompanyUserFolderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioObtenerPorFolderIdCompanyUserFolderGet(
    params?: UsuarioObtenerPorFolderIdCompanyUserFolderGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioObtenerPorFolderIdCompanyUserFolderGet$Response(
      params,
      context
    ).pipe(map((r: StrictHttpResponse<any>): any => r.body));
  }

  /** Path part for operation `usuarioEnviarMultiplesCorreosGet()` */
  static readonly UsuarioEnviarMultiplesCorreosGetPath =
    '/usuario/enviar-multiples-correos';

  /**
   * sendMessageToMultipleEmails.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioEnviarMultiplesCorreosGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioEnviarMultiplesCorreosGet$Response(
    params?: UsuarioEnviarMultiplesCorreosGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioEnviarMultiplesCorreosGet(
      this.http,
      this.rootUrl,
      params,
      context
    );
  }

  /**
   * sendMessageToMultipleEmails.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `usuarioEnviarMultiplesCorreosGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioEnviarMultiplesCorreosGet(
    params?: UsuarioEnviarMultiplesCorreosGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioEnviarMultiplesCorreosGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `usuarioEnviarCvCorreoGet()` */
  static readonly UsuarioEnviarCvCorreoGetPath = '/usuario/enviar-cv-correo';

  /**
   * sendCvToRecruiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `usuarioEnviarCvCorreoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  usuarioEnviarCvCorreoGet$Response(
    params?: UsuarioEnviarCvCorreoGet$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<any>> {
    return usuarioEnviarCvCorreoGet(this.http, this.rootUrl, params, context);
  }

  usuarioEnviarCvCorreoGet(
    params?: UsuarioEnviarCvCorreoGet$Params,
    context?: HttpContext
  ): Observable<any> {
    return this.usuarioEnviarCvCorreoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  updateUrlAvatar(file: File): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/avatar`;
    const formData = new FormData();
    formData.append('urlAvatar', file);
    return this.http.post(url, formData);
  }

  getProfile(idUser: string): Observable<ApiResponse<{ user: Profile }>> {
    const url = `${this.config.rootUrl}/usuario/${idUser}`;
    return this.http.get<ApiResponse<{ user: Profile }>>(url);
  }

  sendVerificationCode(email: string): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/enviar-codigo-verificacion`;
    return this.http.post(url, { email });
  }

  verifyCode(email: string, verificationCode: string): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/verificar?email=${email}&verificationCode=${verificationCode}`;
    return this.http.get(url);
  }

  updatePersonalFile(idUser: string, urlPersonalFile: string): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/carpeta-personal/${idUser}`;
    return this.http.patch(url, { urlPersonalFile });
  }

  updateProfile(data: {
    idDistrict?: string;
    identificationDocument?: string;
    immigrationCard?: string | null;
    birthDate?: string;
    telfOne?: string;
    telfTwo?: string | null;
    annexedOne?: string | null;
    annexedTwo?: string | null;
    address?: string;
    passport?: string | null;
    urlPersonalFile?: string | null;
  }): Observable<any> {
    const url = `${this.config.rootUrl}/usuario`;

    const payload = {
      idDistrict: data.idDistrict ?? null,
      identificationDocument: data.identificationDocument ?? null,
      immigrationCard: data.immigrationCard ?? null,
      birthDate: data.birthDate ?? null,
      telfOne: data.telfOne ?? null,
      telfTwo: data.telfTwo ?? null,
      annexedOne: data.annexedOne ?? null,
      annexedTwo: data.annexedTwo ?? null,
      address: data.address ?? null,
      passport: data.passport ?? null,
      urlPersonalFile: data.urlPersonalFile ?? null,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    return this.http.patch(url, payload, { headers });
  }

  updatePersonalInformation(personalInformation?: string): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/informacion-personal`;

    const payload = {
      personalInformation: personalInformation ?? null,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    return this.http.patch(url, payload, { headers });
  }

  sendRecoveryCode(email: string): Observable<any> {
    const url = `${
      this.config.rootUrl
    }/usuario/enviar-codigo-recuperacion?email=${encodeURIComponent(email)}`;
    return this.http.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
  }

  updatePasswordByRecoveryCode(payload: {
    email: string;
    recoveryCode: string;
    password: string;
  }): Observable<any> {
    const url = `${this.config.rootUrl}/usuario/contrasenia-por-codigo-recuperacion`;
    return this.http.patch(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
  }
}
